var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartner1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "partner 1",
    clipPath: "url(#clip0_6052_27308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 18.5C4.02919 18.5 0 14.4708 0 9.5C0 4.52919 4.02919 0.5 9 0.5C13.9708 0.5 18 4.52919 18 9.5C18 14.4708 13.9708 18.5 9 18.5Z",
    fill: "#34C77E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8791 6.58452C12.9426 5.62546 11.5183 5.41564 10.3033 5.98264C9.738 6.24646 9.34425 6.63571 9.06357 7.07671C9.03263 7.12508 8.96625 7.12508 8.93588 7.07671C8.65463 6.63571 8.26088 6.24646 7.69557 5.98264C6.48113 5.41564 5.05744 5.62602 4.12088 6.58396C2.93794 7.79446 2.94638 9.73396 4.14619 10.9338L8.87232 14.9534C8.946 15.0158 9.05344 15.0158 9.12713 14.9534L13.8533 10.9338C15.0531 9.73452 15.0615 7.79502 13.8791 6.58452Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6052_27308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner1);
export default __webpack_public_path__ + "static/media/partner1.f49e6ca4d0e5b9123d5fceea13d8d9b9.svg";
export { ForwardRef as ReactComponent };